import React from 'react';

const EndScreen = ({ onNewScenario, onNewRole, scenes = [], userChoices = [] }) => {
  // Format the story summary from all scenes
  const generateStorySummary = () => {
    if (!scenes || scenes.length === 0) {
      return 'Your adventure has concluded, but no details of your journey were recorded.';
    }

    // Create a summary paragraph from all the scenes
    return scenes.map((scene, index) => {
      const sceneText = scene.text || 'The adventure continued...';
      const userChoice = userChoices[index] ? `\n\nYou chose: ${userChoices[index]}` : '';
      
      return `Scene ${index + 1}: ${sceneText}${userChoice}`;
    }).join('\n\n');
  };

  return (
    <div className="card">
      <h2>Your Story Has Reached Its End</h2>
      <p style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
        Thank you for exploring this possible future. Here's a summary of your journey:
      </p>
      
      <div className="story-summary" style={{ 
        backgroundColor: 'rgba(0, 0, 0, 0.2)', 
        padding: '20px', 
        borderRadius: '8px',
        maxHeight: '300px',
        overflowY: 'auto',
        margin: '1rem 0',
        whiteSpace: 'pre-line',
        lineHeight: '1.5',
        fontSize: '0.95rem'
      }}>
        {generateStorySummary()}
      </div>
      
      <p style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>What would you like to do next?</p>
      
      <div style={{ margin: '2rem 0' }}>
        <button onClick={onNewScenario}>Create a New Scenario</button>
        <button onClick={onNewRole}>Choose a Different Role</button>
      </div>
    </div>
  );
};

export default EndScreen;
